import { Box, Flex, Heading, Stack } from '@chakra-ui/react'
import type { FC } from 'react'

import useGetObject from '@app/hooks/useGetObject'
import AddWorkItemButton from '@app/next/changelog/components/addWorkItemButton'
import ContainerFilters from '@app/next/changelog/components/containerFilters'
import LayoutRow from '@app/next/changelog/components/layoutRow'
import SendReportButton from '@app/pages/shared/sendReportButton'
import Can from '@app/shared/authorization/can'
import { RecurringReportConfigurationServiceEnum } from '@graphql/types'

type Props = {
  strategyId: string
}

const Hero: FC<Props> = ({ strategyId }) => {
  const strategy = useGetObject(strategyId, 'strategy')

  return (
    <LayoutRow>
      <Stack gap={4} my={[4, null, 6]} data-testid="hero">
        <Heading flex="1" size="xl">
          Changelog - {strategy.name}
        </Heading>
        <Flex gap={2}>
          <Box flex={1}>
            <ContainerFilters strategyId={strategyId} />
          </Box>
          <Can I="create" an="entity">
            <AddWorkItemButton />
          </Can>
          <SendReportButton
            strategyId={strategyId}
            reportType={RecurringReportConfigurationServiceEnum.SendChangelog}
          />
        </Flex>
      </Stack>
    </LayoutRow>
  )
}

export default Hero
